import { createContext } from 'react'

export type User = {
  name: string
  email: string
  image: string
  userIds: string[]
  hasOrgAccess: boolean
  hasPersonalLinksAccess: boolean
  organizationId?: string
}

export type UserContextType = {
  user?: User | null
  setUser: (user: User | null) => void
}

export const UserContext = createContext<UserContextType | undefined>(undefined)
